import { AxiosError } from "axios";

type BackendErrorResponse = {
  message?: string | string[];
  errors?: string[];
  error?: string;
};

const DEFAULT_ERROR_MESSAGE = "Something went wrong. Please try again.";

export const getErrorMessage = (error: unknown): string => {
  // Axios Error
  if (error instanceof AxiosError) {
    const data = error.response?.data as BackendErrorResponse | undefined;

    // message: string | string[]
    if (data?.message) {
      return Array.isArray(data.message)
        ? data.message.join(", ")
        : data.message;
    }

    // errors: string[]
    if (data?.errors && Array.isArray(data.errors)) {
      return data.errors.join(", ");
    }

    // error: string
    if (data?.error) {
      return data.error;
    }

    // fallback axios message
    return error.message || DEFAULT_ERROR_MESSAGE;
  }

  // Native Error
  if (error instanceof Error) {
    return error.message;
  }

  // Wenn string geworfen wurde
  if (typeof error === "string") {
    return error;
  }

  // Unknown fallback
  return DEFAULT_ERROR_MESSAGE;
};